import request from '@shared/api/request';
import { API_BOOKING_DEVICES_PATH, API_BOOKING_PATH } from '@shared/constants/pathsConstants';
import {
    Booking,
    BookingRequestParams,
    BookingsRequestParams,
    CancelBookingRequestParams,
    ClosestBookingRequestParams,
    CreateBookingRequestParams,
    Device,
    DevicesResponse,
    DevicesSearchRequestParams,
    UpdateBookingRequestParams,
} from '@pages/booking/types';
import { AxiosResponse } from 'axios';
import { BookingState } from '@pages/booking/store';

export function getBookingDevices({
    location,
    type,
    search,
    favoriteUserId,
    showOnlyMy,
    schemeId,
}: DevicesSearchRequestParams): Promise<AxiosResponse<DevicesResponse>> {
    return request.get(`${API_BOOKING_PATH}/${API_BOOKING_DEVICES_PATH}/${showOnlyMy ? 'my/' : ''}`, {
        params: {
            location: location || undefined,
            type: type || undefined,
            search: search || undefined,
            favorite_user_id: favoriteUserId || undefined,
            scheme_id: schemeId || undefined,
        },
    });
}

export function getBookingDeviceFullInfo(id: Device['pk']): Promise<AxiosResponse<BookingState['fullDeviceInfo']>> {
    return request.get(`${API_BOOKING_PATH}/${API_BOOKING_DEVICES_PATH}/${id}/info/`);
}

export function getBookingDevicesLocations(): Promise<AxiosResponse<BookingState['locations']>> {
    return request.get(`${API_BOOKING_PATH}/${API_BOOKING_DEVICES_PATH}/locations/`);
}

export function getBookings({
    device,
    range,
}: BookingsRequestParams): Promise<AxiosResponse<BookingState['bookings']>> {
    const newEndDate = structuredClone(range.endDate);
    newEndDate.setDate(newEndDate.getDate() + 1); // increase date by one day to include last day of range

    return request.get(`${API_BOOKING_PATH}/`, {
        params: {
            device_id: device,
            from: range.startDate,
            to: newEndDate,
        },
    });
}

export function getBooking({ id }: BookingRequestParams): Promise<AxiosResponse<Booking>> {
    return request.get(`${API_BOOKING_PATH}/${id}/`);
}

export function getClosestBooking({
    device,
    from,
    slots,
}: ClosestBookingRequestParams): Promise<AxiosResponse<Booking | ''>> {
    return request.get(`${API_BOOKING_PATH}/next/`, {
        params: {
            device_id: device,
            from: from,
            slots: slots ? slots.toString() : undefined,
        },
    });
}

export function createBooking({
    device,
    booked_from,
    booked_to,
    slots,
    comment,
    access,
    // should_change_password,
    // should_disable_pubkey,
}: CreateBookingRequestParams): Promise<AxiosResponse<Booking>> {
    return request.post(`${API_BOOKING_PATH}/`, {
        device_id: device,
        booked_from: booked_from,
        booked_to: booked_to,
        slots: slots || undefined,
        comment: comment,
        access: access,
        // should_change_password: should_change_password,
        // should_disable_pubkey: should_disable_pubkey,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
}

export function updateBooking({
    bookingId,
    booked_to,
    comment,
    access,
    slots,
}: UpdateBookingRequestParams): Promise<AxiosResponse<Booking>> {
    return request.patch(`${API_BOOKING_PATH}/${bookingId}/`, {
        booked_to: booked_to,
        comment: comment,
        access: access,
        slots: slots || undefined,
    });
}

export function cancelBooking({ bookingId }: CancelBookingRequestParams): Promise<AxiosResponse<Booking>> {
    return request.delete(`${API_BOOKING_PATH}/${bookingId}/`);
}
